var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/logout/viewmodels/index',["require", "exports", "common/viewmodelbase", "models/portal"], function (require, exports, Common, Portal) {
    "use strict";
    var LogoutViewModel = (function (_super) {
        __extends(LogoutViewModel, _super);
        function LogoutViewModel() {
            _super.call(this);
        }
        LogoutViewModel.prototype.onActivated = function (context) {
            var shell = Portal.Context.shell;
            var userManager = shell.userManager;
            userManager.signOut();
        };
        return LogoutViewModel;
    }(Common.ViewModelBase));
    var instance = new LogoutViewModel();
    return instance;
});

